module.exports = __webpack_public_path__ + "portal-static/img/icon-video-view.8beb6add.png";